export {default} from './ListingDetailModel';

export {ListingDetailModelType} from './ListingDetailModel';



// WEBPACK FOOTER //
// ./src/models/ListingDetailModel/index.ts